import type { RulesConditionResult } from '@onefootprint/request-types/dashboard';

/**
 * The condition that set a rules node's value, or `undefined` if the default did. The node takes the group of the
 * first condition that held, in `groupResults` order. `assignedValue` reads `<hidden>` without
 * `DecryptOnboardingData`; the rule results need no decrypt scope.
 */
export const getFiredRuleId = (groupResults: RulesConditionResult[]) =>
  groupResults.find(({ result }) => result)?.ruleId;
